import { observable, action } from 'mobx'
import api from '../api'

class ConfirmCustomerStore {
  @observable confirmationId = undefined
  @observable errors = undefined

  @action.bound confirm(id) {
    if(this.confirmationId) {
      return
    }
    this.confirmationId = id

    return api.User.confirmCustomer({
      confirmationId: this.confirmationId
    })
    .catch(action((err) => {
      this.errors = err
    }))
  }
}

export default new ConfirmCustomerStore()



// WEBPACK FOOTER //
// ./src/stores/confirmCustomerStore.js